/* eslint-disable no-console */

const imagesBlocks = document.querySelectorAll('.wp-block-custom-gallery-gallery .can-fullscreen .wp-block-custom-gallery-custom-image');

imagesBlocks.forEach((imageBlock) => {
	imageBlock.querySelector('img').addEventListener('click', () => {
		imagesBlocks.forEach((block) => {
			block.classList.remove('is-fullscreen');
		});
		imageBlock.classList.add('is-fullscreen');
	});
	imageBlock.querySelector('.close-fullscreen').addEventListener('click', () => {
		imageBlock.classList.remove('is-fullscreen');
	});
});
/* eslint-enable no-console */
